<template>
    <div class="generator__panel">
        <div class="panel-animation">
            <div class="logos">
                <template v-if="!wallpaper.pattern.isCorporate">
                    <div @click="activateLogo" class="logos__logo" :class="wallpaper.logo ? 'is-active' : ''">
                        <img :src="logoSrc">
                    </div>
                    <div @click="deactivateLogo" class="logos__no-logo" :class="!wallpaper.logo ? 'is-active' : ''">
                        <img src="../../assets/no-logo.svg">
                    </div>
                </template>
            </div>
            <div v-bar class="panel-content patterns">
                <div class="panel-content__scroll">
                    <ul>
                        <app-pattern v-for="(pattern, index)  in patterns"
                                     :key="'pattern-' + index"
                                     :activePattern="wallpaper.pattern"
                                     :pattern="pattern"
                                     @colorChanged="onColorChange"
                                     @patternSelected="onPatternSelect"
                        >
                        </app-pattern>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pattern from '../panels/Pattern';

    export default {
        components: {
            appPattern: Pattern
        },
        props: ['patterns', 'wallpaper'],
        computed: {
            logoSrc() {
                if (this.wallpaper.pattern.isBW) {
                    return require('../../assets/logos/logo-sipgate.svg');
                } else {
                    return require('../../assets/logos/logo-' + this.wallpaper.pattern.name + '.svg');
                }

            }
        },
        methods: {
            activateLogo() {
                this.wallpaper.logo = true;
                this.eventHub.$emit('refreshPreview');
            },
            deactivateLogo() {
                this.wallpaper.logo = false;
                this.eventHub.$emit('refreshPreview');
            },
            onColorChange() {
                this.wallpaper.logoImage = null;
                this.eventHub.$emit('colorChanged');
            },
            onPatternSelect(pattern) {
                this.wallpaper.pattern = pattern;
                this.wallpaper.logoImage = null;
                if (pattern.isCorporate) {
                    this.wallpaper.logo = false;
                }
                this.eventHub.$emit('patternSelected');
                this.eventHub.$emit('refreshPattern');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .logos {
        display: flex;
        height: 40px;
        margin-bottom: 21px;

        &__logo,
        &__no-logo {
            border: 1px solid rgba(255, 255, 255, 0.16);
            border-radius: 4px;
            cursor: pointer;
            height: 40px;
            transition: border .2s linear;

            &:hover, &.is-active {
                border: 1px solid rgba(255, 255, 255, 1);
            }
        }

        &__logo {
            float: left;
            margin-right: 24px;

            img {
                border-radius: 5px;
                height: 20px;
                margin: 8px 9px;
                width: auto;
            }
        }

        &__no-logo {
            img {
                height: 13px;
                margin: 14px 10px 0 10px;
                width: auto;
            }
        }
    }

    .patterns {
        height: calc(100vh - 255px);

        .pattern {
            @media (min-width: 768px) {
                width: calc(50% - 8px);
                margin-buttom: 16px;
            }

            &:nth-child(2n) {
                margin-right: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/panels/Patterns.vue